import {
    Grid,
    Button,
    Typography,
} from "@material-ui/core";
import { Link } from "react-router-dom";
import React from 'react'
import roleManager from "../roles";

const AttachmentFiles = ({ data }) => {
    let { additionalFiles, setAdditionalFiles, onSubmitEmploye, removeFile } = data
    return (
        <Grid xs={12} container>
            <Grid xs={12}>
                {
                    roleManager('employeeLookup', "sections", "attachments") ?
                        <Grid xs={12} lg={6} container>
                            <Grid xs={12} className="mt30 pr40">
                                <Grid xs={12} className="mbold">
                                    Attach Additional Files
                                </Grid>
                                {
                                    !additionalFiles.length
                                        ? (
                                            <Grid xs={12}>

                                                <Grid xs={12} id="Step2DragFile" className="Step2DragFile mt14">

                                                    <Button
                                                        onClick={($event) => {
                                                            const input = document.getElementById('additional-files-input');

                                                            input.click();
                                                        }}>Select Files</Button>
                                                </Grid>
                                                <input
                                                    id="additional-files-input"
                                                    type="file"
                                                    multiple="multiple"
                                                    hidden="true"
                                                    onChange={($event) => {
                                                        setAdditionalFiles($event.target.files);
                                                    }}
                                                />
                                            </Grid>
                                        )
                                        : (
                                            <Grid className="Step2DragFile files-tag-container">
                                                {
                                                    Array
                                                        .from(additionalFiles)
                                                        .map(
                                                            (file, fileIndex) => (
                                                                <Grid className="files-tag position-relative">
                                                                    <Grid className="d-flex justify-content-end position-absolute r-0">
                                                                        <Button
                                                                            className="dustbinBtn min-width-auto dustbinBtn-size-auto-100"
                                                                            onClick={
                                                                                $e => {
                                                                                    removeFile(fileIndex)
                                                                                }
                                                                            }></Button>
                                                                    </Grid>
                                                                    <p className="attatchmentTag">
                                                                        {file.name}
                                                                    </p>
                                                                </Grid>
                                                            )
                                                        )
                                                }
                                            </Grid>
                                        )
                                }
                            </Grid>
                        </Grid> : ""
                }


                <form onSubmit={onSubmitEmploye}>
                    <Grid xs={12} className="mt12 pr70">
                        <Grid xs={12} container justify="space-between">
                            {/* <Link to="/employees" className="LinkButtonBack">Back</Link> */}
                            <Button
                                type='submit'
                                className="LinkButton"
                                disabled={!additionalFiles.length} style={{ marginTop: '10px' }}>Save & Continue</Button>
                        </Grid>
                    </Grid>
                </form>
            </Grid>


        </Grid>
    )
}

export default AttachmentFiles